import { defineMessages } from 'react-intl';

export const transcriptorRecordingMessages = defineMessages({
  modalTitle: {
    id: 'transcriptorRecording.modalTitle',
    defaultMessage: 'Create Transcriptor Report',
  },
  confirmCloseWhileUploading: {
    id: 'transcriptorRecording.confirmCloseWhileUploading',
    defaultMessage:
      'File upload is in progress. Are you sure you want to close? All progress will be lost.',
  },
  confirmCloseTitle: {
    id: 'transcriptorRecording.confirmCloseTitle',
    defaultMessage: 'Cancel Upload',
  },
  // UI labels
  startRecordingButton: {
    id: 'transcriptorRecording.startRecordingButton',
    defaultMessage: 'Start recording',
  },
  uploadButton: {
    id: 'transcriptorRecording.uploadButton',
    defaultMessage: 'Upload files',
  },
  uploadingMessage: {
    id: 'transcriptorRecording.uploadingMessage',
    defaultMessage: 'Uploading...',
  },
  audioFileDescription: {
    id: 'transcriptorRecording.audioFileDescription',
    defaultMessage: 'Or drag and drop audio file here',
  },
  changeButton: {
    id: 'transcriptorRecording.changeButton',
    defaultMessage: 'Change',
  },
  invalidFileTypeError: {
    id: 'transcriptorRecording.invalidFileTypeError',
    defaultMessage:
      'Invalid file type ({fileType}) for file "{fileName}". Please upload an audio file (MP3, MP4, M4A, WAV, OGG, WebM)',
  },
  uploadError: {
    id: 'transcriptorRecording.uploadError',
    defaultMessage: 'Failed to upload file',
  },
  microphonePermissionError: {
    id: 'transcriptorRecording.microphonePermissionError',
    defaultMessage: 'Unable to access microphone. Please check your settings.',
  },
  specialtySelectionTitle: {
    id: 'transcriptorRecording.specialtySelectionTitle',
    defaultMessage: 'Specialty',
  },
  specialtySelectionPlaceholder: {
    id: 'transcriptorRecording.specialtySelectionPlaceholder',
    defaultMessage: 'Select a specialty',
  },
  specialtySelectionEmpty: {
    id: 'transcriptorRecording.specialtySelectionEmpty',
    defaultMessage: 'No specialties available',
  },
  requiredTemplatesTitle: {
    id: 'transcriptorRecording.requiredTemplatesTitle',
    defaultMessage: 'Required templates',
  },
  templatesSelectionTitle: {
    id: 'transcriptorRecording.templatesSelectionTitle',
    defaultMessage: 'Additional documents',
  },
  templatesSelectionPlaceholder: {
    id: 'transcriptorRecording.templatesSelectionPlaceholder',
    defaultMessage: 'Select templates to generate',
  },
  templatesSelectionEmpty: {
    id: 'transcriptorRecording.templatesSelectionEmpty',
    defaultMessage:
      'Only required documents will be generated for this specialty',
  },
  microphoneConfigTitle: {
    id: 'transcriptorRecording.microphoneConfigTitle',
    defaultMessage: 'Microphone Configuration',
  },
  microphoneConfigDescription: {
    id: 'transcriptorRecording.microphoneConfigDescription',
    defaultMessage:
      'Please select your microphone and ensure it is working properly.',
  },
  microphonePlaceholder: {
    id: 'transcriptorRecording.microphonePlaceholder',
    defaultMessage: 'Select a microphone',
  },
  audioLevelLabel: {
    id: 'transcriptorRecording.audioLevelLabel',
    defaultMessage: 'Audio Level',
  },
  microphonePlacementTitle: {
    id: 'transcriptorRecording.microphonePlacementTitle',
    defaultMessage: 'Microphone Placement',
  },
  newRecordingTab: {
    id: 'transcriptorRecording.newRecordingTab',
    defaultMessage: 'New Recording',
  },
  uploadFileTab: {
    id: 'transcriptorRecording.uploadFileTab',
    defaultMessage: 'Upload File',
  },
  fileUploadTitle: {
    id: 'transcriptorRecording.fileUploadTitle',
    defaultMessage: 'Upload Audio File',
  },
  processingMessage: {
    id: 'transcriptorRecording.processingMessage',
    defaultMessage: 'Processing audio file...',
  },
  fileSizeMB: {
    id: 'transcriptorRecording.fileSizeMB',
    defaultMessage: '{size} MB',
  },
  microphonePlacementAlt: {
    id: 'transcriptorRecording.microphonePlacementAlt',
    defaultMessage: 'Microphone placement',
  },
  microphoneAccessDenied: {
    id: 'transcriptorRecording.microphoneAccessDenied',
    defaultMessage: 'Microphone access denied',
  },
  microphoneFallbackLabel: {
    id: 'transcriptorRecording.microphoneFallbackLabel',
    defaultMessage: 'Microphone {deviceId}',
  },
  defaultMicrophone: {
    id: 'transcriptorRecording.defaultMicrophone',
    defaultMessage: 'Default Microphone',
  },
  testMicrophone: {
    id: 'transcriptorRecording.testMicrophone',
    defaultMessage: 'Test Microphone',
  },
  microphonePermissionPermanentlyDenied: {
    id: 'transcriptorRecording.microphonePermissionPermanentlyDenied',
    defaultMessage:
      'Microphone access is permanently blocked. Please enable it in your browser settings and refresh the page.',
  },
  microphonePermissionPermanentlyDeniedInstructions: {
    id: 'transcriptorRecording.microphonePermissionPermanentlyDeniedInstructions',
    defaultMessage:
      'Click on the lock icon in the address bar and allow microphone access.',
  },
  microphoneNotFound: {
    id: 'transcriptorRecording.microphoneNotFound',
    defaultMessage:
      'No microphone found. Please connect a microphone and try again.',
  },
  microphoneNotReadable: {
    id: 'transcriptorRecording.microphoneNotReadable',
    defaultMessage:
      'Microphone is being used by another application. Please close other applications and try again.',
  },
  microphoneConstraintError: {
    id: 'transcriptorRecording.microphoneConstraintError',
    defaultMessage:
      'The selected microphone does not meet the requirements. Please try another microphone.',
  },
  soundCheckChecking: {
    id: 'transcriptorRecording.soundCheckChecking',
    defaultMessage: 'Checking microphone...',
  },
  soundCheckDetected: {
    id: 'transcriptorRecording.soundCheckDetected',
    defaultMessage: 'Microphone ready',
  },
  soundCheckNoSound: {
    id: 'transcriptorRecording.soundCheckNoSound',
    defaultMessage: 'No sound detected. Check your microphone.',
  },
  deviceWarningIosSafari: {
    id: 'transcriptorRecording.deviceWarningIosSafari',
    defaultMessage: 'Recording works best in Safari on iOS devices.',
  },
  deviceWarningWakeLock: {
    id: 'transcriptorRecording.deviceWarningWakeLock',
    defaultMessage:
      'Screen may turn off during recording. Keep the screen active manually.',
  },
});
